// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__wNnFb","sidebar__wrapper":"Sidebar_sidebar__wrapper__PixAL","sidebar__support":"Sidebar_sidebar__support__EdjOY"};